export enum AdvisoryDistributionModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
